/*! jquery-touchSwipe v0.0.1 ~ (c) 2015-2016 mattbryson ~ https://github.com/mattbryson/TouchSwipe-Jquery-Plugin */
import $ from 'jquery'
const VERSION = '0.0.1'
const LEFT = 'left'
const RIGHT = 'right'
const UP = 'up'
const DOWN = 'down'
const IN = 'in'
const OUT = 'out'

const NONE = 'none'
const AUTO = 'auto'

const SWIPE = 'swipe'
const PINCH = 'pinch'
const TAP = 'tap'
const DOUBLE_TAP = 'doubletap'
const LONG_TAP = 'longtap'
const HOLD = 'hold'

const HORIZONTAL = 'horizontal'
const VERTICAL = 'vertical'

const ALL_FINGERS = 'all'

const DOUBLE_TAP_THRESHOLD = 10

const PHASE_START = 'start'
const PHASE_MOVE = 'move'
const PHASE_END = 'end'
const PHASE_CANCEL = 'cancel'

const SUPPORTS_TOUCH = 'ontouchstart' in window

const SUPPORTS_POINTER_IE10 = window.navigator.msPointerEnabled && !window.navigator.pointerEnabled && !SUPPORTS_TOUCH

const SUPPORTS_POINTER = (window.navigator.pointerEnabled || window.navigator.msPointerEnabled) && !SUPPORTS_TOUCH

const PLUGIN_NS = 'TouchSwipe'
let defaults = {
    fingers: 1, // 滑动时监控有几根手指触摸
    threshold: 75, // 触发滑动的最小距离
    cancelThreshold: null,
    pinchThreshold: 20,
    maxTimeThreshold: null,
    fingerReleaseThreshold: 250,
    longTapThreshold: 500,
    doubleTapThreshold: 200,
    swipe: null,
    swipeLeft: null,
    swipeRight: null,
    swipeUp: null,
    swipeDown: null,
    swipeStatus: null,
    pinchIn: null,
    pinchOut: null,
    pinchStatus: null,
    click: null,
    tap: null,
    doubleTap: null,
    longTap: null,
    hold: null,
    triggerOnTouchEnd: true,
    triggerOnTouchLeave: false,
    allowPageScroll: "auto",
    fallbackToMouseEvents: true,
    excludedElements: "label, button, input, select, textarea, a, .noSwipe",
    preventDefaultEvents: true
}
/**
 * Applies TouchSwipe behaviour to one or more jQuery objects.
 * The TouchSwipe plugin can be instantiated via this method, or methods within
 * TouchSwipe can be executed via this method as per jQuery plugin architecture.
 * An existing plugin can have its options changed simply by re calling .swipe(options)
 * @see TouchSwipe
 * @class
 * @param {Mixed} method If the current DOMNode is a TouchSwipe object, and <code>method</code> is a TouchSwipe method, then
 * the <code>method</code> is executed, and any following arguments are passed to the TouchSwipe method.
 * If <code>method</code> is an object, then the TouchSwipe class is instantiated on the current DOMNode, passing the
 * configuration properties defined in the object. See TouchSwipe
 *
 */
$.fn.swipe = function(method) {
    const $this = $(this);
    const plugin = $this.data(PLUGIN_NS);

    //Check if we are already instantiated and trying to execute a method
    if (plugin && typeof method === 'string') {
        if (plugin[method]) {
            return plugin[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else {
            $.error(`Method ${method} does not exist on jQuery.swipe`);
        }
    }

    //Else update existing plugin with new options hash
    else if (plugin && typeof method === 'object') {
        plugin['option'].apply(this, arguments);
    }

    //Else not instantiated and trying to pass init object (or nothing)
    else if (!plugin && (typeof method === 'object' || !method)) {
        return init.apply(this, arguments);
    }

    return $this;
};

/**
 * The version of the plugin
 * @readonly
 */
$.fn.swipe.version = VERSION;



//Expose our defaults so a user could override the plugin defaults
$.fn.swipe.defaults = defaults;

/**
 * The phases that a touch event goes through.  The <code>phase</code> is passed to the event handlers.
 * These properties are read only, attempting to change them will not alter the values passed to the event handlers.
 * @namespace
 * @readonly
 * @property {string} PHASE_START Constant indicating the start phase of the touch event. Value is <code>"start"</code>.
 * @property {string} PHASE_MOVE Constant indicating the move phase of the touch event. Value is <code>"move"</code>.
 * @property {string} PHASE_END Constant indicating the end phase of the touch event. Value is <code>"end"</code>.
 * @property {string} PHASE_CANCEL Constant indicating the cancel phase of the touch event. Value is <code>"cancel"</code>.
 */
$.fn.swipe.phases = {
    PHASE_START,
    PHASE_MOVE,
    PHASE_END,
    PHASE_CANCEL
};

/**
 * The direction constants that are passed to the event handlers.
 * These properties are read only, attempting to change them will not alter the values passed to the event handlers.
 * @namespace
 * @readonly
 * @property {string} LEFT Constant indicating the left direction. Value is <code>"left"</code>.
 * @property {string} RIGHT Constant indicating the right direction. Value is <code>"right"</code>.
 * @property {string} UP Constant indicating the up direction. Value is <code>"up"</code>.
 * @property {string} DOWN Constant indicating the down direction. Value is <code>"cancel"</code>.
 * @property {string} IN Constant indicating the in direction. Value is <code>"in"</code>.
 * @property {string} OUT Constant indicating the out direction. Value is <code>"out"</code>.
 */
$.fn.swipe.directions = {
    LEFT,
    RIGHT,
    UP,
    DOWN,
    IN,
    OUT
};

/**
 * The page scroll constants that can be used to set the value of <code>allowPageScroll</code> option
 * These properties are read only
 * @namespace
 * @readonly
 * @see $.fn.swipe.defaults#allowPageScroll
 * @property {string} NONE Constant indicating no page scrolling is allowed. Value is <code>"none"</code>.
 * @property {string} HORIZONTAL Constant indicating horizontal page scrolling is allowed. Value is <code>"horizontal"</code>.
 * @property {string} VERTICAL Constant indicating vertical page scrolling is allowed. Value is <code>"vertical"</code>.
 * @property {string} AUTO Constant indicating either horizontal or vertical will be allowed, depending on the swipe handlers registered. Value is <code>"auto"</code>.
 */
$.fn.swipe.pageScroll = {
    NONE,
    HORIZONTAL,
    VERTICAL,
    AUTO
};

/**
 * Constants representing the number of fingers used in a swipe.  These are used to set both the value of <code>fingers</code> in the
 * options object, as well as the value of the <code>fingers</code> event property.
 * These properties are read only, attempting to change them will not alter the values passed to the event handlers.
 * @namespace
 * @readonly
 * @see $.fn.swipe.defaults#fingers
 * @property {string} ONE Constant indicating 1 finger is to be detected / was detected. Value is <code>1</code>.
 * @property {string} TWO Constant indicating 2 fingers are to be detected / were detected. Value is <code>2</code>.
 * @property {string} THREE Constant indicating 3 finger are to be detected / were detected. Value is <code>3</code>.
 * @property {string} FOUR Constant indicating 4 finger are to be detected / were detected. Not all devices support this. Value is <code>4</code>.
 * @property {string} FIVE Constant indicating 5 finger are to be detected / were detected. Not all devices support this. Value is <code>5</code>.
 * @property {string} ALL Constant indicating any combination of finger are to be detected.  Value is <code>"all"</code>.
 */
$.fn.swipe.fingers = {
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    FIVE: 5,
    ALL: ALL_FINGERS
};
/**
 * Initialise the plugin for each DOM element matched
 * This creates a new instance of the main TouchSwipe class for each DOM element, and then
 * saves a reference to that instance in the elements data property.
 * @internal
 */
function init(options) {
    //Prep and extend the options
    if (options && (options.allowPageScroll === undefined && (options.swipe !== undefined || options.swipeStatus !== undefined))) {
        options.allowPageScroll = NONE;
    }

    //Check for deprecated options
    //Ensure that any old click handlers are assigned to the new tap, unless we have a tap
    if (options.click !== undefined && options.tap === undefined) {
        options.tap = options.click;
    }

    if (!options) {
        options = {};
    }

    //pass empty object so we dont modify the defaults
    options = $.extend({}, $.fn.swipe.defaults, options);

    //For each element instantiate the plugin
    return this.each(function() {
        const $this = $(this);

        //Check we havent already initialised the plugin
        let plugin = $this.data(PLUGIN_NS);

        if (!plugin) {
            plugin = new TouchSwipe(this, options);
            $this.data(PLUGIN_NS, plugin);
        }
    });
}
/**
 * Main TouchSwipe Plugin Class.
 * Do not use this to construct your TouchSwipe object, use the jQuery plugin method $.fn.swipe(); {@link $.fn.swipe}
 * @private
 * @name TouchSwipe
 * @param {DOMNode} element The HTML DOM object to apply to plugin to
 * @param {Object} options The options to configure the plugin with.  @link {$.fn.swipe.defaults}
 * @see $.fh.swipe.defaults
 * @see $.fh.swipe
 * @class
 */
function TouchSwipe(element, options) {
    //take a local/instacne level copy of the options - should make it this.options really...
    var options = $.extend({}, options);

    const useTouchEvents = (SUPPORTS_TOUCH || SUPPORTS_POINTER || !options.fallbackToMouseEvents);
    const START_EV = useTouchEvents ? (SUPPORTS_POINTER ? (SUPPORTS_POINTER_IE10 ? 'MSPointerDown' : 'pointerdown') : 'touchstart') : 'mousedown';
    const MOVE_EV = useTouchEvents ? (SUPPORTS_POINTER ? (SUPPORTS_POINTER_IE10 ? 'MSPointerMove' : 'pointermove') : 'touchmove') : 'mousemove';
    const END_EV = useTouchEvents ? (SUPPORTS_POINTER ? (SUPPORTS_POINTER_IE10 ? 'MSPointerUp' : 'pointerup') : 'touchend') : 'mouseup';

    //we manually detect leave on touch devices, so null event here
    const LEAVE_EV = useTouchEvents ? (SUPPORTS_POINTER ? 'mouseleave' : null) : 'mouseleave';

    const CANCEL_EV = (SUPPORTS_POINTER ? (SUPPORTS_POINTER_IE10 ? 'MSPointerCancel' : 'pointercancel') : 'touchcancel');

    //touch properties
    let distance = 0;

    let direction = null;
    let currentDirection = null;
    let duration = 0;
    let startTouchesDistance = 0;
    let endTouchesDistance = 0;
    let pinchZoom = 1;
    let pinchDistance = 0;
    let pinchDirection = 0;
    let maximumsMap = null;



    //jQuery wrapped element for this instance
    let $element = $(element);

    //Current phase of th touch cycle
    let phase = "start";

    // the current number of fingers being used.
    let fingerCount = 0;

    //track mouse points / delta
    const fingerData = {};

    //track times
    let startTime = 0;

    let endTime = 0;
    let previousTouchEndTime = 0;
    let fingerCountAtRelease = 0;
    let doubleTapStartTime = 0;

    //Timeouts
    let singleTapTimeout = null;

    let holdTimeout = null;

    // Add gestures to all swipable areas if supported
    try {
        $element.bind(START_EV, touchStart);
        $element.bind(CANCEL_EV, touchCancel);
    } catch (e) {
        $.error(`events not supported ${START_EV},${CANCEL_EV} on jQuery.swipe`);
    }

    //
    //Public methods
    //

    /**
     * re-enables the swipe plugin with the previous configuration
     * @function
     * @name $.fn.swipe#enable
     * @return {DOMNode} The Dom element that was registered with TouchSwipe
     * @example $("#element").swipe("enable");
     */
    this.enable = function() {
        $element.bind(START_EV, touchStart);
        $element.bind(CANCEL_EV, touchCancel);
        return $element;
    };

    /**
     * disables the swipe plugin
     * @function
     * @name $.fn.swipe#disable
     * @return {DOMNode} The Dom element that is now registered with TouchSwipe
     * @example $("#element").swipe("disable");
     */
    this.disable = function() {
        removeListeners();
        return $element;
    };

    /**
     * Destroy the swipe plugin completely. To use any swipe methods, you must re initialise the plugin.
     * @function
     * @name $.fn.swipe#destroy
     * @example $("#element").swipe("destroy");
     */
    this.destroy = function() {
        removeListeners();
        $element.data(PLUGIN_NS, null);
        $element = null;
    };


    /**
     * Allows run time updating of the swipe configuration options.
     * @function
     * @name $.fn.swipe#option
     * @param {String} property The option property to get or set, or a has of multiple options to set
     * @param {Object} [value] The value to set the property to
     * @return {Object} If only a property name is passed, then that property value is returned. If nothing is passed the current options hash is returned.
     * @example $("#element").swipe("option", "threshold"); // return the threshold
     * @example $("#element").swipe("option", "threshold", 100); // set the threshold after init
     * @example $("#element").swipe("option", {threshold:100, fingers:3} ); // set multiple properties after init
     * @example $("#element").swipe({threshold:100, fingers:3} ); // set multiple properties after init - the "option" method is optional!
     * @example $("#element").swipe("option"); // Return the current options hash
     * @see $.fn.swipe.defaults
     *
     */
    this.option = function(property, value) {

        if (typeof property === 'object') {
            options = $.extend(options, property);
        } else if (options[property] !== undefined) {
            if (value === undefined) {
                return options[property];
            } else {
                options[property] = value;
            }
        } else if (!property) {
            return options;
        } else {
            $.error(`Option ${property} does not exist on jQuery.swipe.options`);
        }

        return null;
    }
    //
    // EVENTS
    //
    /**
     * Event handler for a touch start event.
     * Stops the default click event from triggering and stores where we touched
     * @inner
     * @param {object} jqEvent The normalised jQuery event object.
     */
    function touchStart(jqEvent) {
        //If we already in a touch event (a finger already in use) then ignore subsequent ones..
        if (getTouchInProgress()) {
            return;
        }

        //Check if this element matches any in the excluded elements selectors,  or its parent is excluded, if so, DON'T swipe
        if ($(jqEvent.target).closest(options.excludedElements, $element).length > 0) {
            return;
        }

        //As we use Jquery bind for events, we need to target the original event object
        //If these events are being programmatically triggered, we don't have an original event object, so use the Jq one.
        const event = jqEvent.originalEvent ? jqEvent.originalEvent : jqEvent;

        let ret;
        let touches = event.touches;
        let evt = touches ? touches[0] : event;

        phase = PHASE_START;

        //If we support touches, get the finger count
        if (touches) {
            // get the total number of fingers touching the screen
            fingerCount = touches.length;
        }
        //Else this is the desktop, so stop the browser from dragging content
        else if (options.preventDefaultEvents !== false) {
            jqEvent.preventDefault(); //call this on jq event so we are cross browser
        }

        //clear vars..
        distance = 0;
        direction = null;
        currentDirection = null;
        pinchDirection = null;
        duration = 0;
        startTouchesDistance = 0;
        endTouchesDistance = 0;
        pinchZoom = 1;
        pinchDistance = 0;
        maximumsMap = createMaximumsData();
        cancelMultiFingerRelease();

        //Create the default finger data
        createFingerData(0, evt);

        // check the number of fingers is what we are looking for, or we are capturing pinches
        if (!touches || (fingerCount === options.fingers || options.fingers === ALL_FINGERS) || hasPinches()) {
            // get the coordinates of the touch
            startTime = getTimeStamp();

            if (fingerCount == 2) {
                //Keep track of the initial pinch distance, so we can calculate the diff later
                //Store second finger data as start
                createFingerData(1, touches[1]);
                startTouchesDistance = endTouchesDistance = calculateTouchesDistance(fingerData[0].start, fingerData[1].start);
            }

            if (options.swipeStatus || options.pinchStatus) {
                ret = triggerHandler(event, phase);
            }
        } else {
            //A touch with more or less than the fingers we are looking for, so cancel
            ret = false;
        }

        //If we have a return value from the users handler, then return and cancel
        if (ret === false) {
            phase = PHASE_CANCEL;
            triggerHandler(event, phase);
            return ret;
        } else {
            if (options.hold) {
                holdTimeout = setTimeout($.proxy(() => {
                    //Trigger the event
                    $element.trigger('hold', [event.target]);
                    //Fire the callback
                    if (options.hold) {
                        ret = options.hold.call($element, event, event.target);
                    }
                }, this), options.longTapThreshold);
            }

            setTouchInProgress(true);
        }

        return null;
    }



    /**
     * Event handler for a touch move event.
     * If we change fingers during move, then cancel the event
     * @inner
     * @param {object} jqEvent The normalised jQuery event object.
     */
    function touchMove(jqEvent) {
        //As we use Jquery bind for events, we need to target the original event object
        //If these events are being programmatically triggered, we don't have an original event object, so use the Jq one.
        const event = jqEvent.originalEvent ? jqEvent.originalEvent : jqEvent;

        //If we are ending, cancelling, or within the threshold of 2 fingers being released, don't track anything..
        if (phase === PHASE_END || phase === PHASE_CANCEL || inMultiFingerRelease())
            return;

        let ret;
        let touches = event.touches;
        let evt = touches ? touches[0] : event;


        //Update the  finger data
        const currentFinger = updateFingerData(evt);
        endTime = getTimeStamp();

        if (touches) {
            fingerCount = touches.length;
        }

        if (options.hold)
            clearTimeout(holdTimeout);

        phase = PHASE_MOVE;

        //If we have 2 fingers get Touches distance as well
        if (fingerCount == 2) {

            //Keep track of the initial pinch distance, so we can calculate the diff later
            //We do this here as well as the start event, in case they start with 1 finger, and the press 2 fingers
            if (startTouchesDistance == 0) {
                //Create second finger if this is the first time...
                createFingerData(1, touches[1]);

                startTouchesDistance = endTouchesDistance = calculateTouchesDistance(fingerData[0].start, fingerData[1].start);
            } else {
                //Else just update the second finger
                updateFingerData(touches[1]);

                endTouchesDistance = calculateTouchesDistance(fingerData[0].end, fingerData[1].end);
                pinchDirection = calculatePinchDirection(fingerData[0].end, fingerData[1].end);
            }

            pinchZoom = calculatePinchZoom(startTouchesDistance, endTouchesDistance);
            pinchDistance = Math.abs(startTouchesDistance - endTouchesDistance);
        }

        if ((fingerCount === options.fingers || options.fingers === ALL_FINGERS) || !touches || hasPinches()) {

            //The overall direction of the swipe. From start to now.
            direction = calculateDirection(currentFinger.start, currentFinger.end);

            //The immediate direction of the swipe, direction between the last movement and this one.
            currentDirection = calculateDirection(currentFinger.last, currentFinger.end);

            //Check if we need to prevent default event (page scroll / pinch zoom) or not
            validateDefaultEvent(jqEvent, currentDirection);

            //Distance and duration are all off the main finger
            distance = calculateDistance(currentFinger.start, currentFinger.end);
            duration = calculateDuration();

            //Cache the maximum distance we made in this direction
            setMaxDistance(direction, distance);

            //Trigger status handler
            ret = triggerHandler(event, phase);


            //If we trigger end events when threshold are met, or trigger events when touch leaves element
            if (!options.triggerOnTouchEnd || options.triggerOnTouchLeave) {

                let inBounds = true;

                //If checking if we leave the element, run the bounds check (we can use touchleave as its not supported on webkit)
                if (options.triggerOnTouchLeave) {
                    const bounds = getbounds(this);
                    inBounds = isInBounds(currentFinger.end, bounds);
                }

                //Trigger end handles as we swipe if thresholds met or if we have left the element if the user has asked to check these..
                if (!options.triggerOnTouchEnd && inBounds) {
                    phase = getNextPhase(PHASE_MOVE);
                }
                //We end if out of bounds here, so set current phase to END, and check if its modified
                else if (options.triggerOnTouchLeave && !inBounds) {
                    phase = getNextPhase(PHASE_END);
                }

                if (phase == PHASE_CANCEL || phase == PHASE_END) {
                    triggerHandler(event, phase);
                }
            }
        } else {
            phase = PHASE_CANCEL;
            triggerHandler(event, phase);
        }

        if (ret === false) {
            phase = PHASE_CANCEL;
            triggerHandler(event, phase);
        }
    }




    /**
     * Event handler for a touch end event.
     * Calculate the direction and trigger events
     * @inner
     * @param {object} jqEvent The normalised jQuery event object.
     */
    function touchEnd(jqEvent) {
        //As we use Jquery bind for events, we need to target the original event object
        //If these events are being programmatically triggered, we don't have an original event object, so use the Jq one.
        const event = jqEvent.originalEvent ? jqEvent.originalEvent : jqEvent;

        const touches = event.touches;

        //If we are still in a touch with the device wait a fraction and see if the other finger comes up
        //if it does within the threshold, then we treat it as a multi release, not a single release and end the touch / swipe
        if (touches) {
            if (touches.length && !inMultiFingerRelease()) {
                startMultiFingerRelease(event);
                return true;
            } else if (touches.length && inMultiFingerRelease()) {
                return true;
            }
        }

        //If a previous finger has been released, check how long ago, if within the threshold, then assume it was a multifinger release.
        //This is used to allow 2 fingers to release fractionally after each other, whilst maintaining the event as containing 2 fingers, not 1
        if (inMultiFingerRelease()) {
            fingerCount = fingerCountAtRelease;
        }

        //Set end of swipe
        endTime = getTimeStamp();

        //Get duration incase move was never fired
        duration = calculateDuration();

        //If we trigger handlers at end of swipe OR, we trigger during, but they didnt trigger and we are still in the move phase
        if (didSwipeBackToCancel() || !validateSwipeDistance()) {
            phase = PHASE_CANCEL;
            triggerHandler(event, phase);
        } else if (options.triggerOnTouchEnd || (options.triggerOnTouchEnd == false && phase === PHASE_MOVE)) {
            //call this on jq event so we are cross browser
            if (options.preventDefaultEvents !== false) {
                jqEvent.preventDefault();
            }
            phase = PHASE_END;
            triggerHandler(event, phase);
        }
        //Special cases - A tap should always fire on touch end regardless,
        //So here we manually trigger the tap end handler by itself
        //We dont run trigger handler as it will re-trigger events that may have fired already
        else if (!options.triggerOnTouchEnd && hasTap()) {
            //Trigger the pinch events...
            phase = PHASE_END;
            triggerHandlerForGesture(event, phase, TAP);
        } else if (phase === PHASE_MOVE) {
            phase = PHASE_CANCEL;
            triggerHandler(event, phase);
        }

        setTouchInProgress(false);

        return null;
    }



    /**
     * Event handler for a touch cancel event.
     * Clears current vars
     * @inner
     */
    function touchCancel() {
        // reset the variables back to default values
        fingerCount = 0;
        endTime = 0;
        startTime = 0;
        startTouchesDistance = 0;
        endTouchesDistance = 0;
        pinchZoom = 1;

        //If we were in progress of tracking a possible multi touch end, then re set it.
        cancelMultiFingerRelease();

        setTouchInProgress(false);
    }


    /**
     * Event handler for a touch leave event.
     * This is only triggered on desktops, in touch we work this out manually
     * as the touchleave event is not supported in webkit
     * @inner
     */
    function touchLeave(jqEvent) {
        //If these events are being programmatically triggered, we don't have an original event object, so use the Jq one.
        const event = jqEvent.originalEvent ? jqEvent.originalEvent : jqEvent;

        //If we have the trigger on leave property set....
        if (options.triggerOnTouchLeave) {
            phase = getNextPhase(PHASE_END);
            triggerHandler(event, phase);
        }
    }

    /**
     * Removes all listeners that were associated with the plugin
     * @inner
     */
    function removeListeners() {
        $element.unbind(START_EV, touchStart);
        $element.unbind(CANCEL_EV, touchCancel);
        $element.unbind(MOVE_EV, touchMove);
        $element.unbind(END_EV, touchEnd);

        //we only have leave events on desktop, we manually calculate leave on touch as its not supported in webkit
        if (LEAVE_EV) {
            $element.unbind(LEAVE_EV, touchLeave);
        }

        setTouchInProgress(false);
    }


    /**
     * Checks if the time and distance thresholds have been met, and if so then the appropriate handlers are fired.
     */
    function getNextPhase(currentPhase) {

        let nextPhase = currentPhase;

        // Ensure we have valid swipe (under time and over distance  and check if we are out of bound...)
        const validTime = validateSwipeTime();
        const validDistance = validateSwipeDistance();
        const didCancel = didSwipeBackToCancel();

        //If we have exceeded our time, then cancel
        if (!validTime || didCancel) {
            nextPhase = PHASE_CANCEL;
        }
        //Else if we are moving, and have reached distance then end
        else if (validDistance && currentPhase == PHASE_MOVE && (!options.triggerOnTouchEnd || options.triggerOnTouchLeave)) {
            nextPhase = PHASE_END;
        }
        //Else if we have ended by leaving and didn't reach distance, then cancel
        else if (!validDistance && currentPhase == PHASE_END && options.triggerOnTouchLeave) {
            nextPhase = PHASE_CANCEL;
        }

        return nextPhase;
    }


    /**
     * Trigger the relevant event handler
     * The handlers are passed the original event, the element that was swiped, and in the case of the catch all handler, the direction that was swiped, "left", "right", "up", or "down"
     * @param {object} event the original event object
     * @param {string} phase the phase of the swipe (start, end cancel etc) {@link $.fn.swipe.phases}
     * @inner
     */
    function triggerHandler(event, phase) {
        let ret;
        let touches = event.touches;

        // SWIPE GESTURES
        if (didSwipe() || hasSwipes()) {
            ret = triggerHandlerForGesture(event, phase, SWIPE);
        }

        // PINCH GESTURES (if the above didn't cancel)
        if ((didPinch() || hasPinches()) && ret !== false) {
            ret = triggerHandlerForGesture(event, phase, PINCH);
        }

        // CLICK / TAP (if the above didn't cancel)
        if (didDoubleTap() && ret !== false) {
            //Trigger the tap events...
            ret = triggerHandlerForGesture(event, phase, DOUBLE_TAP);
        }

        // CLICK / TAP (if the above didn't cancel)
        else if (didLongTap() && ret !== false) {
            //Trigger the tap events...
            ret = triggerHandlerForGesture(event, phase, LONG_TAP);
        }

        // CLICK / TAP (if the above didn't cancel)
        else if (didTap() && ret !== false) {
            //Trigger the tap event..
            ret = triggerHandlerForGesture(event, phase, TAP);
        }

        // If we are cancelling the gesture, then manually trigger the reset handler
        if (phase === PHASE_CANCEL) {
            if (hasSwipes()) {
                ret = triggerHandlerForGesture(event, phase, SWIPE);
            }

            if (hasPinches()) {
                ret = triggerHandlerForGesture(event, phase, PINCH);
            }
            touchCancel(event);
        }

        // If we are ending the gesture, then manually trigger the reset handler IF all fingers are off
        if (phase === PHASE_END) {
            //If we support touch, then check that all fingers are off before we cancel
            if (touches) {
                if (!touches.length) {
                    touchCancel(event);
                }
            } else {
                touchCancel(event);
            }
        }

        return ret;
    }



    /**
     * Trigger the relevant event handler
     * The handlers are passed the original event, the element that was swiped, and in the case of the catch all handler, the direction that was swiped, "left", "right", "up", or "down"
     * @param {object} event the original event object
     * @param {string} phase the phase of the swipe (start, end cancel etc) {@link $.fn.swipe.phases}
     * @param {string} gesture the gesture to trigger a handler for : PINCH or SWIPE {@link $.fn.swipe.gestures}
     * @return Boolean False, to indicate that the event should stop propagation, or void.
     * @inner
     */
    function triggerHandlerForGesture(event, phase, gesture) {

        let ret;

        //SWIPES....
        if (gesture == SWIPE) {
            //Trigger status every time..
            $element.trigger('swipeStatus', [phase, direction || null, distance || 0, duration || 0, fingerCount, fingerData, currentDirection]);

            if (options.swipeStatus) {
                ret = options.swipeStatus.call($element, event, phase, direction || null, distance || 0, duration || 0, fingerCount, fingerData, currentDirection);
                //If the status cancels, then dont run the subsequent event handlers..
                if (ret === false) return false;
            }

            if (phase == PHASE_END && validateSwipe()) {

                //Cancel any taps that were in progress...
                clearTimeout(singleTapTimeout);
                clearTimeout(holdTimeout);

                $element.trigger('swipe', [direction, distance, duration, fingerCount, fingerData, currentDirection]);

                if (options.swipe) {
                    ret = options.swipe.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection);
                    //If the status cancels, then dont run the subsequent event handlers..
                    if (ret === false) return false;
                }

                //trigger direction specific event handlers
                switch (direction) {
                    case LEFT:
                        $element.trigger('swipeLeft', [direction, distance, duration, fingerCount, fingerData, currentDirection]);

                        if (options.swipeLeft) {
                            ret = options.swipeLeft.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection);
                        }
                        break;

                    case RIGHT:
                        $element.trigger('swipeRight', [direction, distance, duration, fingerCount, fingerData, currentDirection]);

                        if (options.swipeRight) {
                            ret = options.swipeRight.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection);
                        }
                        break;

                    case UP:
                        $element.trigger('swipeUp', [direction, distance, duration, fingerCount, fingerData, currentDirection]);

                        if (options.swipeUp) {
                            ret = options.swipeUp.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection);
                        }
                        break;

                    case DOWN:
                        $element.trigger('swipeDown', [direction, distance, duration, fingerCount, fingerData, currentDirection]);

                        if (options.swipeDown) {
                            ret = options.swipeDown.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection);
                        }
                        break;
                }
            }
        }


        //PINCHES....
        if (gesture == PINCH) {
            $element.trigger('pinchStatus', [phase, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData]);

            if (options.pinchStatus) {
                ret = options.pinchStatus.call($element, event, phase, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData);
                //If the status cancels, then dont run the subsequent event handlers..
                if (ret === false) return false;
            }

            if (phase == PHASE_END && validatePinch()) {

                switch (pinchDirection) {
                    case IN:
                        $element.trigger('pinchIn', [pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData]);

                        if (options.pinchIn) {
                            ret = options.pinchIn.call($element, event, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData);
                        }
                        break;

                    case OUT:
                        $element.trigger('pinchOut', [pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData]);

                        if (options.pinchOut) {
                            ret = options.pinchOut.call($element, event, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData);
                        }
                        break;
                }
            }
        }

        if (gesture == TAP) {
            if (phase === PHASE_CANCEL || phase === PHASE_END) {

                clearTimeout(singleTapTimeout);
                clearTimeout(holdTimeout);

                //If we are also looking for doubelTaps, wait incase this is one...
                if (hasDoubleTap() && !inDoubleTap()) {
                    doubleTapStartTime = getTimeStamp();

                    //Now wait for the double tap timeout, and trigger this single tap
                    //if its not cancelled by a double tap
                    singleTapTimeout = setTimeout($.proxy(() => {
                        doubleTapStartTime = null;
                        $element.trigger('tap', [event.target]);

                        if (options.tap) {
                            ret = options.tap.call($element, event, event.target);
                        }
                    }, this), options.doubleTapThreshold);

                } else {
                    doubleTapStartTime = null;
                    $element.trigger('tap', [event.target]);
                    if (options.tap) {
                        ret = options.tap.call($element, event, event.target);
                    }
                }
            }
        } else if (gesture == DOUBLE_TAP) {
            if (phase === PHASE_CANCEL || phase === PHASE_END) {
                clearTimeout(singleTapTimeout);
                clearTimeout(holdTimeout);
                doubleTapStartTime = null;
                $element.trigger('doubletap', [event.target]);

                if (options.doubleTap) {
                    ret = options.doubleTap.call($element, event, event.target);
                }
            }
        } else if (gesture == LONG_TAP) {
            if (phase === PHASE_CANCEL || phase === PHASE_END) {
                clearTimeout(singleTapTimeout);
                doubleTapStartTime = null;

                $element.trigger('longtap', [event.target]);
                if (options.longTap) {
                    ret = options.longTap.call($element, event, event.target);
                }
            }
        }

        return ret;
    }
    //
    // GESTURE VALIDATION
    //

    /**
     * Checks the user has swipe far enough
     * @return Boolean if <code>threshold</code> has been set, return true if the threshold was met, else false.
     * If no threshold was set, then we return true.
     * @inner
     */
    function validateSwipeDistance() {
        let valid = true;
        //If we made it past the min swipe distance..
        if (options.threshold !== null) {
            valid = distance >= options.threshold;
        }

        return valid;
    }

    /**
     * Checks the user has swiped back to cancel.
     * @return Boolean if <code>cancelThreshold</code> has been set, return true if the cancelThreshold was met, else false.
     * If no cancelThreshold was set, then we return true.
     * @inner
     */
    function didSwipeBackToCancel() {
        let cancelled = false;
        if (options.cancelThreshold !== null && direction !== null) {
            cancelled = (getMaxDistance(direction) - distance) >= options.cancelThreshold;
        }

        return cancelled;
    }

    /**
     * Checks the user has pinched far enough
     * @return Boolean if <code>pinchThreshold</code> has been set, return true if the threshold was met, else false.
     * If no threshold was set, then we return true.
     * @inner
     */
    function validatePinchDistance() {
        if (options.pinchThreshold !== null) {
            return pinchDistance >= options.pinchThreshold;
        }
        return true;
    }

    /**
     * Checks that the time taken to swipe meets the minimum / maximum requirements
     * @return Boolean
     * @inner
     */
    function validateSwipeTime() {
        let result;
        //If no time set, then return true
        if (options.maxTimeThreshold) {
            if (duration >= options.maxTimeThreshold) {
                result = false;
            } else {
                result = true;
            }
        } else {
            result = true;
        }

        return result;
    }



    /**
     * Checks direction of the swipe and the value allowPageScroll to see if we should allow or prevent the default behaviour from occurring.
     * This will essentially allow page scrolling or not when the user is swiping on a touchSwipe object.
     * @param {object} jqEvent The normalised jQuery representation of the event object.
     * @param {string} direction The direction of the event. See {@link $.fn.swipe.directions}
     * @see $.fn.swipe.directions
     * @inner
     */
    function validateDefaultEvent(jqEvent, direction) {

        //If the option is set, allways allow the event to bubble up (let user handle weirdness)
        if (options.preventDefaultEvents === false) {
            return;
        }

        if (options.allowPageScroll === NONE) {
            jqEvent.preventDefault();
        } else {
            const auto = options.allowPageScroll === AUTO;

            switch (direction) {
                case LEFT:
                    if ((options.swipeLeft && auto) || (!auto && options.allowPageScroll != HORIZONTAL)) {
                        jqEvent.preventDefault();
                    }
                    break;

                case RIGHT:
                    if ((options.swipeRight && auto) || (!auto && options.allowPageScroll != HORIZONTAL)) {
                        jqEvent.preventDefault();
                    }
                    break;

                case UP:
                    if ((options.swipeUp && auto) || (!auto && options.allowPageScroll != VERTICAL)) {
                        jqEvent.preventDefault();
                    }
                    break;

                case DOWN:
                    if ((options.swipeDown && auto) || (!auto && options.allowPageScroll != VERTICAL)) {
                        jqEvent.preventDefault();
                    }
                    break;
            }
        }

    }


    // PINCHES
    /**
     * Returns true of the current pinch meets the thresholds
     * @return Boolean
     * @inner
     */
    function validatePinch() {
        const hasCorrectFingerCount = validateFingers();
        const hasEndPoint = validateEndPoint();
        const hasCorrectDistance = validatePinchDistance();
        return hasCorrectFingerCount && hasEndPoint && hasCorrectDistance;

    }

    /**
     * Returns true if any Pinch events have been registered
     * @return Boolean
     * @inner
     */
    function hasPinches() {
        //Enure we dont return 0 or null for false values
        return !!(options.pinchStatus || options.pinchIn || options.pinchOut);
    }

    /**
     * Returns true if we are detecting pinches, and have one
     * @return Boolean
     * @inner
     */
    function didPinch() {
        //Enure we dont return 0 or null for false values
        return !!(validatePinch() && hasPinches());
    }




    // SWIPES
    /**
     * Returns true if the current swipe meets the thresholds
     * @return Boolean
     * @inner
     */
    function validateSwipe() {
        //Check validity of swipe
        const hasValidTime = validateSwipeTime();
        const hasValidDistance = validateSwipeDistance();
        const hasCorrectFingerCount = validateFingers();
        const hasEndPoint = validateEndPoint();
        const didCancel = didSwipeBackToCancel();

        // if the user swiped more than the minimum length, perform the appropriate action
        // hasValidDistance is null when no distance is set
        const valid = !didCancel && hasEndPoint && hasCorrectFingerCount && hasValidDistance && hasValidTime;

        return valid;
    }

    /**
     * Returns true if any Swipe events have been registered
     * @return Boolean
     * @inner
     */
    function hasSwipes() {
        //Enure we dont return 0 or null for false values
        return !!(options.swipe || options.swipeStatus || options.swipeLeft || options.swipeRight || options.swipeUp || options.swipeDown);
    }


    /**
     * Returns true if we are detecting swipes and have one
     * @return Boolean
     * @inner
     */
    function didSwipe() {
        //Enure we dont return 0 or null for false values
        return !!(validateSwipe() && hasSwipes());
    }

    /**
     * Returns true if we have matched the number of fingers we are looking for
     * @return Boolean
     * @inner
     */
    function validateFingers() {
        //The number of fingers we want were matched, or on desktop we ignore
        return ((fingerCount === options.fingers || options.fingers === ALL_FINGERS) || !SUPPORTS_TOUCH);
    }

    /**
     * Returns true if we have an end point for the swipe
     * @return Boolean
     * @inner
     */
    function validateEndPoint() {
        //We have an end value for the finger
        return fingerData[0].end.x !== 0;
    }

    // TAP / CLICK
    /**
     * Returns true if a click / tap events have been registered
     * @return Boolean
     * @inner
     */
    function hasTap() {
        //Enure we dont return 0 or null for false values
        return !!(options.tap);
    }

    /**
     * Returns true if a double tap events have been registered
     * @return Boolean
     * @inner
     */
    function hasDoubleTap() {
        //Enure we dont return 0 or null for false values
        return !!(options.doubleTap);
    }

    /**
     * Returns true if any long tap events have been registered
     * @return Boolean
     * @inner
     */
    function hasLongTap() {
        //Enure we dont return 0 or null for false values
        return !!(options.longTap);
    }

    /**
     * Returns true if we could be in the process of a double tap (one tap has occurred, we are listening for double taps, and the threshold hasn't past.
     * @return Boolean
     * @inner
     */
    function validateDoubleTap() {
        if (doubleTapStartTime == null) {
            return false;
        }
        const now = getTimeStamp();
        return (hasDoubleTap() && ((now - doubleTapStartTime) <= options.doubleTapThreshold));
    }

    /**
     * Returns true if we could be in the process of a double tap (one tap has occurred, we are listening for double taps, and the threshold hasn't past.
     * @return Boolean
     * @inner
     */
    function inDoubleTap() {
        return validateDoubleTap();
    }


    /**
     * Returns true if we have a valid tap
     * @return Boolean
     * @inner
     */
    function validateTap() {
        return ((fingerCount === 1 || !SUPPORTS_TOUCH) && (isNaN(distance) || distance < options.threshold));
    }

    /**
     * Returns true if we have a valid long tap
     * @return Boolean
     * @inner
     */
    function validateLongTap() {
        //slight threshold on moving finger
        return ((duration > options.longTapThreshold) && (distance < DOUBLE_TAP_THRESHOLD));
    }

    /**
     * Returns true if we are detecting taps and have one
     * @return Boolean
     * @inner
     */
    function didTap() {
        //Enure we dont return 0 or null for false values
        return !!(validateTap() && hasTap());
    }


    /**
     * Returns true if we are detecting double taps and have one
     * @return Boolean
     * @inner
     */
    function didDoubleTap() {
        //Enure we dont return 0 or null for false values
        return !!(validateDoubleTap() && hasDoubleTap());
    }

    /**
     * Returns true if we are detecting long taps and have one
     * @return Boolean
     * @inner
     */
    function didLongTap() {
        //Enure we dont return 0 or null for false values
        return !!(validateLongTap() && hasLongTap());
    }




    // MULTI FINGER TOUCH
    /**
     * Starts tracking the time between 2 finger releases, and keeps track of how many fingers we initially had up
     * @inner
     */
    function startMultiFingerRelease(event) {
        previousTouchEndTime = getTimeStamp();
        fingerCountAtRelease = event.touches.length + 1;
    }

    /**
     * Cancels the tracking of time between 2 finger releases, and resets counters
     * @inner
     */
    function cancelMultiFingerRelease() {
        previousTouchEndTime = 0;
        fingerCountAtRelease = 0;
    }

    /**
     * Checks if we are in the threshold between 2 fingers being released
     * @return Boolean
     * @inner
     */
    function inMultiFingerRelease() {

        let withinThreshold = false;

        if (previousTouchEndTime) {
            const diff = getTimeStamp() - previousTouchEndTime;
            if (diff <= options.fingerReleaseThreshold) {
                withinThreshold = true;
            }
        }

        return withinThreshold;
    }


    /**
     * gets a data flag to indicate that a touch is in progress
     * @return Boolean
     * @inner
     */
    function getTouchInProgress() {
        //strict equality to ensure only true and false are returned
        return !!($element.data(`${PLUGIN_NS}_intouch`) === true);
    }

    /**
     * Sets a data flag to indicate that a touch is in progress
     * @param {boolean} val The value to set the property to
     * @inner
     */
    function setTouchInProgress(val) {

        //If destroy is called in an event handler, we have no el, and we have already cleaned up, so return.
        if (!$element) {
            return;
        }

        //Add or remove event listeners depending on touch status
        if (val === true) {
            $element.bind(MOVE_EV, touchMove);
            $element.bind(END_EV, touchEnd);

            //we only have leave events on desktop, we manually calcuate leave on touch as its not supported in webkit
            if (LEAVE_EV) {
                $element.bind(LEAVE_EV, touchLeave);
            }
        } else {

            $element.unbind(MOVE_EV, touchMove, false);
            $element.unbind(END_EV, touchEnd, false);

            //we only have leave events on desktop, we manually calcuate leave on touch as its not supported in webkit
            if (LEAVE_EV) {
                $element.unbind(LEAVE_EV, touchLeave, false);
            }
        }


        //strict equality to ensure only true and false can update the value
        $element.data(`${PLUGIN_NS}_intouch`, val === true);
    }


    /**
     * Creates the finger data for the touch/finger in the event object.
     * @param {int} id The id to store the finger data under (usually the order the fingers were pressed)
     * @param {object} evt The event object containing finger data
     * @return finger data object
     * @inner
     */
    function createFingerData(id, evt) {
        const f = {
            start: {
                x: 0,
                y: 0
            },
            last: {
                x: 0,
                y: 0
            },
            end: {
                x: 0,
                y: 0
            }
        };
        f.start.x = f.last.x = f.end.x = evt.pageX || evt.clientX;
        f.start.y = f.last.y = f.end.y = evt.pageY || evt.clientY;
        fingerData[id] = f;
        return f;
    }

    /**
     * Updates the finger data for a particular event object
     * @param {object} evt The event object containing the touch/finger data to upadte
     * @return a finger data object.
     * @inner
     */
    function updateFingerData(evt) {
        const id = evt.identifier !== undefined ? evt.identifier : 0;
        let f = getFingerData(id);

        if (f === null) {
            f = createFingerData(id, evt);
        }

        f.last.x = f.end.x;
        f.last.y = f.end.y;

        f.end.x = evt.pageX || evt.clientX;
        f.end.y = evt.pageY || evt.clientY;

        return f;
    }

    /**
     * Returns a finger data object by its event ID.
     * Each touch event has an identifier property, which is used
     * to track repeat touches
     * @param {int} id The unique id of the finger in the sequence of touch events.
     * @return a finger data object.
     * @inner
     */
    function getFingerData(id) {
        return fingerData[id] || null;
    }


    /**
     * Sets the maximum distance swiped in the given direction.
     * If the new value is lower than the current value, the max value is not changed.
     * @param {string}  direction The direction of the swipe
     * @param {int}  distance The distance of the swipe
     * @inner
     */
    function setMaxDistance(direction, distance) {
        distance = Math.max(distance, getMaxDistance(direction));
        maximumsMap[direction].distance = distance;
    }

    /**
     * gets the maximum distance swiped in the given direction.
     * @param {string}  direction The direction of the swipe
     * @return int  The distance of the swipe
     * @inner
     */
    function getMaxDistance(direction) {
        if (maximumsMap[direction]) return maximumsMap[direction].distance;
        return undefined;
    }

    /**
     * Creats a map of directions to maximum swiped values.
     * @return Object A dictionary of maximum values, indexed by direction.
     * @inner
     */
    function createMaximumsData() {
        const maxData = {};
        maxData[LEFT] = createMaximumVO(LEFT);
        maxData[RIGHT] = createMaximumVO(RIGHT);
        maxData[UP] = createMaximumVO(UP);
        maxData[DOWN] = createMaximumVO(DOWN);

        return maxData;
    }

    /**
     * Creates a map maximum swiped values for a given swipe direction
     * @param {string} The direction that these values will be associated with
     * @return Object Maximum values
     * @inner
     */
    function createMaximumVO(dir) {
        return {
            direction: dir,
            distance: 0
        }
    }
    //
    // MATHS / UTILS
    //

    /**
     * Calculate the duration of the swipe
     * @return int
     * @inner
     */
    function calculateDuration() {
        return endTime - startTime;
    }

    /**
     * Calculate the distance between 2 touches (pinch)
     * @param {point} startPoint A point object containing x and y co-ordinates
     * @param {point} endPoint A point object containing x and y co-ordinates
     * @return int;
     * @inner
     */
    function calculateTouchesDistance(startPoint, endPoint) {
        const diffX = Math.abs(startPoint.x - endPoint.x);
        const diffY = Math.abs(startPoint.y - endPoint.y);

        return Math.round(Math.sqrt(diffX * diffX + diffY * diffY));
    }

    /**
     * Calculate the zoom factor between the start and end distances
     * @param {int} startDistance Distance (between 2 fingers) the user started pinching at
     * @param {int} endDistance Distance (between 2 fingers) the user ended pinching at
     * @return float The zoom value from 0 to 1.
     * @inner
     */
    function calculatePinchZoom(startDistance, endDistance) {
        const percent = (endDistance / startDistance) * 1;
        return percent.toFixed(2);
    }


    /**
     * Returns the pinch direction, either IN or OUT for the given points
     * @return string Either {@link $.fn.swipe.directions.IN} or {@link $.fn.swipe.directions.OUT}
     * @see $.fn.swipe.directions
     * @inner
     */
    function calculatePinchDirection() {
        if (pinchZoom < 1) {
            return OUT;
        } else {
            return IN;
        }
    }


    /**
     * Calculate the length / distance of the swipe
     * @param {point} startPoint A point object containing x and y co-ordinates
     * @param {point} endPoint A point object containing x and y co-ordinates
     * @return int
     * @inner
     */
    function calculateDistance(startPoint, endPoint) {
        return Math.round(Math.sqrt(Math.pow(endPoint.x - startPoint.x, 2) + Math.pow(endPoint.y - startPoint.y, 2)));
    }

    /**
     * Calculate the angle of the swipe
     * @param {point} startPoint A point object containing x and y co-ordinates
     * @param {point} endPoint A point object containing x and y co-ordinates
     * @return int
     * @inner
     */
    function calculateAngle(startPoint, endPoint) {
        const x = startPoint.x - endPoint.x;
        const y = endPoint.y - startPoint.y;
        const r = Math.atan2(y, x); //radians
        let angle = Math.round(r * 180 / Math.PI); //degrees

        //ensure value is positive
        if (angle < 0) {
            angle = 360 - Math.abs(angle);
        }

        return angle;
    }

    /**
     * Calculate the direction of the swipe
     * This will also call calculateAngle to get the latest angle of swipe
     * @param {point} startPoint A point object containing x and y co-ordinates
     * @param {point} endPoint A point object containing x and y co-ordinates
     * @return string Either {@link $.fn.swipe.directions.LEFT} / {@link $.fn.swipe.directions.RIGHT} / {@link $.fn.swipe.directions.DOWN} / {@link $.fn.swipe.directions.UP}
     * @see $.fn.swipe.directions
     * @inner
     */
    function calculateDirection(startPoint, endPoint) {
        const angle = calculateAngle(startPoint, endPoint);

        if ((angle <= 45) && (angle >= 0)) {
            return LEFT;
        } else if ((angle <= 360) && (angle >= 315)) {
            return LEFT;
        } else if ((angle >= 135) && (angle <= 225)) {
            return RIGHT;
        } else if ((angle > 45) && (angle < 135)) {
            return DOWN;
        } else {
            return UP;
        }
    }


    /**
     * Returns a MS time stamp of the current time
     * @return int
     * @inner
     */
    function getTimeStamp() {
        const now = new Date();
        return now.getTime();
    }



    /**
     * Returns a bounds object with left, right, top and bottom properties for the element specified.
     * @param {DomNode} The DOM node to get the bounds for.
     */
    function getbounds(el) {
        el = $(el);
        const offset = el.offset();

        const bounds = {
            left: offset.left,
            right: offset.left + el.outerWidth(),
            top: offset.top,
            bottom: offset.top + el.outerHeight()
        };

        return bounds;
    }


    /**
     * Checks if the point object is in the bounds object.
     * @param {object} point A point object.
     * @param {int} point.x The x value of the point.
     * @param {int} point.y The x value of the point.
     * @param {object} bounds The bounds object to test
     * @param {int} bounds.left The leftmost value
     * @param {int} bounds.right The righttmost value
     * @param {int} bounds.top The topmost value
     * @param {int} bounds.bottom The bottommost value
     */
    function isInBounds(point, bounds) {
        return (point.x > bounds.left && point.x < bounds.right && point.y > bounds.top && point.y < bounds.bottom);
    }
}



// WEBPACK FOOTER //
// ./mobile-core/src/libs/jquery-touch.js